import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/exchange/det_coupon_top_bg.png';
import _imports_1 from '@/assets/img/exchange/det_coupon_line_center_bg.png';
import _imports_2 from '@/assets/img/exchange/lab_selected.png';
const _withScopeId = n => (_pushScopeId("data-v-134b425a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "exchangeDetail" };
const _hoisted_2 = { class: "detailBox" };
const _hoisted_3 = { class: "detailHeader" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "top_bg" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "coupon_top_bg",
        src: _imports_0,
        alt: ""
    })
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "detailCenter" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_1,
        alt: ""
    })
], -1));
const _hoisted_6 = { class: "courseList white-bg p-lr20 p-t24 p-b20 border-box" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "imgBox" };
const _hoisted_9 = { class: "imgLeft" };
const _hoisted_10 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_11 = { class: "info flex-1 border-box" };
const _hoisted_12 = { class: "title text-ell2 font-32" };
const _hoisted_13 = { class: "teacher text-overflow font-28" };
const _hoisted_14 = { class: "expert gray-6" };
const _hoisted_15 = { class: "hospital gray-6" };
const _hoisted_16 = {
    key: 0,
    class: "studyInfo gray-6 font-24"
};
const _hoisted_17 = { class: "date text-overflow" };
const _hoisted_18 = { class: "selectedIcon" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1));
const _hoisted_20 = [
    _hoisted_19
];
const _hoisted_21 = { class: "exchangeStatus" };
const _hoisted_22 = { class: "statusText font-40 font-w500" };
const _hoisted_23 = {
    key: 0,
    class: "font-28 validityPeriod"
};
const _hoisted_24 = ["onClick"];
import { Toast } from 'vant';
import { useRoute } from 'vue-router';
import { hostPath } from '@/public/utils/basePath';
import { courseSearch, exchangeMake } from '@api/exchange';
import { appPort, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isApp = ref(appPort());
        /* 返回 */
        const backFn = () => {
            history.go(-1);
        };
        const courseList = ref([]);
        const selectData = ref({});
        const headerData = ref({});
        const route = useRoute();
        const code = String(route.params.code);
        const getData = () => {
            courseSearch({
                code: code
            }).then((res) => {
                if (res.code === 200) {
                    courseList.value = res.data.items;
                    headerData.value = res.data;
                }
            });
        };
        // 选择要兑换的课程
        const selectCourse = val => {
            selectData.value = val;
        };
        // 兑换按钮
        const exchangeBut = () => {
            if (Object.keys(selectData.value).length === 0) {
                Toast('请选择要兑换的课程！');
                return;
            }
            exchangeMake({
                code: code,
                productId: selectData.value.productId,
                nonce: selectData.value.nonce
            }).then((res) => {
                if (res.code === 200) {
                    Toast('兑换成功!');
                    location.href = `${hostPath}/learn/exchange/detail/${code}`;
                }
            });
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '选择课程'
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _hoisted_5,
                        _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item, key) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "flex p-lr20 p-l20 p-b20",
                                    key: key,
                                    onClick: _withModifiers(($event) => (selectCourse(item)), ["stop"])
                                }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                                            [_directive_lazy, item.cover]
                                        ]),
                                        (item.courseTypeName)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.courseTypeName), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(item.courseName), 1),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.expertNames) + " ", 1),
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.hospitalNames), 1)
                                        ]),
                                        (item.startedAt)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, _toDisplayString(item.startedAt) + "开营", 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_20, 512), [
                                        [_vShow, selectData.value.productId == item.productId]
                                    ])
                                ], 8, _hoisted_7));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(code)), 1),
                            (headerData.value?.endedDate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, " 有效期至 " + _toDisplayString(headerData.value?.endedDate), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "buttonBox white-bg font-w500 font-28",
                        onClick: _withModifiers(exchangeBut, ["stop"])
                    }, [
                        _createElementVNode("button", {
                            class: _normalizeClass({ backF60: selectData.value.productId })
                        }, "立即兑换", 2)
                    ], 8, _hoisted_24)
                ])
            ]));
        };
    }
});
